module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/tornado-1eea9a31a5b14ad2be44be0f2f5863db.svg";